/**
 * Created by meirr on 1/22/17.
 */
define(function (require) {

    var _ = require('underscore');
    var lpBaseListController = require('web-agent-assets-js/lpBaseListController');

    var BASE = lpBaseListController;
    var APPLICATION_TYPE = 'lpMessagingAgentListController';

    function searchSuccessHandler(res) {

        this.errorsCount = 0;

        this.model.set(this.getModelPaths().data, createDataObject());
        this.model.set(this.getModelPaths().array, res.data);
        this.model.set(this.getModelPaths().count, res.count);

        this.setState(BASE.STATES.FETCHED, "ok", res.count);

        LE.crossModule("reporting", LE.media.actions.command, "webAgent:agentListMessagingDatabarReady");

        function createDataObject() {
            var resData = res.data || [];
            var data = {};

            resData.forEach(function(item){
                data[item.agentId] = item;
            });

            return data;
        }
    }

    function searchErrorHandler(response) {
        this.logger.error('failed to fetch data for Messaging Agent List.');

        // bumping the error count.
        this.errorsCount++;

        if (this.errorsCount >= this.settings.maxErrorsBeforeDisplayErrorState) {
            this.setState(BASE.STATES.ERROR);
        }
    }

    function handlePollingCallback() {

    }

    var MessagingAgentListController = BASE.extend(function (options) {
       this.service = options.service;
       this.pollingRefreshRate = options.pollingRefreshRate;
    });

    MessagingAgentListController.prototype.applicationType = APPLICATION_TYPE;

    MessagingAgentListController.prototype.startPolling = function () {
        this.fetch();
    };

    MessagingAgentListController.prototype.stopPolling = function () {
        if (this.stopPollingHandler) {
            this.stopPollingHandler();
            this.stopPollingHandler = null;
        }
        this.clearState();
    };

    MessagingAgentListController.prototype.fetch = function () {
        this.stopPolling();
        this.errorsCount = 0;

        // if we are in a fetching state, cancel the fetch process.
        if (this.getStatus() === BASE.STATES.FETCHING) {
            return;
        }

        this.setState(BASE.STATES.FETCHING);
        var reqObj = this.createRequestDataObject();
        reqObj.pollingTimeout = this.pollingRefreshRate;

        this.stopPollingHandler = this.service.searchAgents(reqObj);
    };

    MessagingAgentListController.prototype.createRequestDataObject = function () {

        var queryParams = {
            offset: 0,
            limit: 50
        };

        var bodyData = {};

        var query = this.lastQuery || {};

        for(var prop in query) {
            switch(prop) {
                case "limit":
                    queryParams[prop] = query[prop];
                    break;
                case "sortTag":
                    queryParams.sort = query[prop] + ":" + query.sortOrder;
                    break;
                case "skip":
                    queryParams.offset = query[prop];
                    break;
                case "agentIds":
                    bodyData.agentIds = query.agentIds && query.agentIds.split(",");
                    break;
                case "agentGroupIds":
                    bodyData.agentGroupIds = query.agentGroupIds && query.agentGroupIds.split(",");
                    break;
                case"skillIds": {
                    bodyData.skillIds = query.skillIds && query.skillIds.split(",");
                    break;
                }
            }
        }

        if(query.agentStatus && query.agentStatus.status) {
            bodyData.status = query.agentStatus.status.split(",");
        } else {
            bodyData.status = _.values(lpTag.WebAgent.logicController.AVAILABILITY_TYPES);
        }


        var requestDataObject = {
            query: queryParams,
            data: bodyData,
            pollingCallback: handlePollingCallback.bind(this),
            success: searchSuccessHandler.bind(this),
            error: searchErrorHandler.bind(this)
        };

        return requestDataObject;
    };

    MessagingAgentListController.prototype.getModelPaths = function() {
        return {
            state: 'messagingAgentList.state',
            count: 'messagingAgentList.count',
            array: 'messagingAgentList.array',
            data: 'messagingAgentList.data',
            lastQuery: 'messagingAgentList.lastQuery'
        };
    };

    MessagingAgentListController.prototype.settings = {
        maxErrorsBeforeDisplayErrorState: 3,
        defaultSearchUIData: {
            limit: 50,
            skip: 0
        }
    };

    lpTag = lpTag || {};
    lpTag.WebAgent = lpTag.WebAgent || {};

    return MessagingAgentListController;

});
